import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { PPTState } from 'egov-api';

export const loadPPTState = createSourcedAction('Load PPT State');
export const pptStateLoadFailed = createSourcedAction('PPT State Load failed');
export const pptStateLoaded = createSourcedAction('PPT State Loaded', props<{ newState: PPTState }>());
